module.exports = __webpack_public_path__ + "img/icon_cn.6fabca64.svg";